// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__YtWni","row":"styles_row__P9n3Q","button":"styles_button__0JxnL","rightIcon":"styles_rightIcon__96ckr","data":"styles_data__qliej"};